import { useEffect, useRef } from 'react';

import { subPageTitleScrollProgress } from '../../../utils/scroll/subPageTitleScrollProgress';

import styles from './MobileSubPageTitleHeader.module.scss';

type Props = {
  title: string;
};

const MobileSubPageTitleHeader = ({ title }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rafId = useRef<number | null>(null);

  useEffect(() => {
    let prevProgress = -1;

    const tick = () => {
      const progress = subPageTitleScrollProgress.current;
      if (progress !== prevProgress) {
        prevProgress = progress;
        if (containerRef.current) {
          const translateY = (1 - progress) * 8;
          containerRef.current.style.opacity = String(progress);
          containerRef.current.style.transform = `translateY(calc(-50% + ${translateY}px))`;
        }
      }
      rafId.current = requestAnimationFrame(tick);
    };

    rafId.current = requestAnimationFrame(tick);

    return () => {
      if (rafId.current !== null) {
        cancelAnimationFrame(rafId.current);
        rafId.current = null;
      }
    };
  }, []);

  return (
    <div ref={containerRef} className={styles.mobileSubPageTitleHeader}>
      {title}
    </div>
  );
};

export default MobileSubPageTitleHeader;
